import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { of } from 'rxjs';

import { providePrimeNG } from 'primeng/config';
import Material from '@primeuix/themes/material';
import { definePreset } from '@primeuix/themes';
import { LOGGER_CONFIG } from 'tmt-logger';

import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { LaunchDarklyService } from './services/launcdarkley.service';
import { tratonPreset } from './primeng-design-tokens/traton-presets';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    LaunchDarklyService,
    BrowserAnimationsModule,
    providePrimeNG({
      translation: {
        weekHeader: 'Week',
      },
      theme: {
        options: {
          darkModeSelector: '.theme-dark',
        },
        preset: definePreset(Material, tratonPreset, {
          components: {
            dialog: {
              extend: {
                size: {
                  maxWidth: '90%',
                },
              },
              css: ({ dt }) => `
                .p-dialog {
                  max-width: ${dt('dialog.size.max.width')};
                }
              `,
            },
            datatable: {
              colorScheme: {
                light: {
                  header: {
                    background: '{surface.50}', // ✅ REPLACED 'background'
                  },
                },
                dark: {
                  header: {
                    background: '{surface.900}', // ✅ REPLACED 'background'
                  },
                },
              },
            },
          },
        }),
      },
    }),
    {
      provide: LOGGER_CONFIG,
      useValue: of(environment.logConfig),
    },
  ],
};
